import { RolesAssessmentTeamEnum } from "@shape/reef-shared";
import type { AssessmentTeamResponse, User } from "@shape/reef-shared";

export interface Step2AssessmentTeamPosition {
  title: string;
  id: number;
}

export const step2FixedPositions: Step2AssessmentTeamPosition[] = [
  {
    title: "ctoStep2.riskAssessmentLeader",
    id: RolesAssessmentTeamEnum.RISK_ASSESSMENT_FACILITY,
  },
  {
    title: "ctoStep1.relevantSuperintendent",
    id: RolesAssessmentTeamEnum.RELEVANT_SUPERINTENDENT,
  },
];

export const step2AdditionalPosition = {
  title: "ctoStep1.addMoreMember",
  subtitle: "ctoStep1.youCanAddMoreMembers",
  label: "formGeneric.nameOrEmail",
  id: RolesAssessmentTeamEnum.OTHER,
};

export const getStep2AssessmentTeamDefaultValue = (
  initialValues: AssessmentTeamResponse[] | undefined,
  roleCode: number
): { userId: number; mail: string } | undefined => {
  const user = initialValues?.find((member) => member.role_code === roleCode)?.user;
  return user ? { userId: user.user_id, mail: user.mail } : undefined;
};

export const getStep2AssessmentTeamAdditionalUsers = (
  initialValues: AssessmentTeamResponse[] | undefined
): User[] | undefined =>
  initialValues
    ?.filter((member) => member.role_code === step2AdditionalPosition.id)
    .map((member) => member.user);
